import styled from "styled-components";

export const PackageSelectionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: 0.25rem;
  height: auto;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  padding: 0 0.5rem 2rem 0.5rem;
  overflow-x: hidden;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    padding: 0 2rem 2rem 2rem;
    gap: 0.5rem;
    margin-top: 1.5rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    padding: 0 2rem;
    margin-top: 1rem;
    gap: 0.75rem;
  }
`;

export const JobNimbusLogo = styled.img`
  width: auto;
  height: 2rem;
  alt: "JobNimbus Logo";
  position: static;
  margin: 0 auto 1rem;
  display: block;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    height: 2rem;
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    margin: 0;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  position: relative;
  margin-bottom: 1rem;
  padding-right: 120px;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    margin-bottom: 1rem;
    padding-right: 160px;
  }
`;

export const PageTitle = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
  position: static;
  margin-bottom: 0;
  opacity: 0.7;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    position: absolute;
    top: 0.5rem;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 0;
  }
`;

export const Bubble = styled.div`
  background: ${(props) => (props.selected ? "#3B5EAB" : "#FFF")};
  border-radius: 0.625rem;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  height: 1.125rem;
  width: 6rem;
  position: absolute;
  margin: auto;
  top: 0.15rem;
  left: 0;
  right: 0;
  opacity: ${(props) => (props.selected ? "100%" : "0")};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.selected ? "#FFF" : "#A9A9A9")};

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    width: 7.5rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    width: 9rem;
  }
`;

export const BubbleText = styled.div`
  text-align: center;
  font-family: "DM Sans";
  font-size: 0.656rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 0.75rem;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 0.25rem;
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  position: relative;
  padding: 0 0.5rem;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    flex-direction: row;
    gap: 0.5rem;
    padding: 0;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    gap: 0.75rem;
  }
`;

export const RowTitle = styled.div`
  color: #3b5eab;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
  margin-bottom: 0.35rem;
  width: 100%;
  position: static;
  padding: 0;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.2rem;
    margin-bottom: 0.4375rem;
  }
`;

export const RowTitleWithToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  width: auto;
  margin-bottom: 1rem;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    margin-bottom: 1.25rem;
  }
`;

export const AssistAIHeaderToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  width: auto;
  margin-bottom: 0.35rem;
  margin-top: 0;
  padding-top: 0;
`;

export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 1.5rem;
  cursor: pointer;
  flex-shrink: 0;
`;

export const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 1.5rem;

  &:before {
    position: absolute;
    content: "";
    height: 1.125rem;
    width: 1.125rem;
    left: 0.1875rem;
    bottom: 0.1875rem;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
  }
`;

export const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${ToggleSlider} {
    background-color: #3b5eab;
  }

  &:checked + ${ToggleSlider}:before {
    transform: translateX(1.3125rem);
  }
`;
// BASE CRM PACKAGE
export const BaseCrmCard = styled.button`
  width: 100%;
  max-width: 360px;
  height: auto;
  min-height: ${(props) => (props.expanded ? "10.1rem" : "4rem")};
  display: flex;
  position: relative;
  align-items: ${(props) => (props.expanded ? "flex-start" : "center")};
  justify-content: ${(props) => (props.expanded ? "flex-start" : "center")};
  flex-direction: column;
  text-align: left;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
  outline: ${(props) => (props.selected ? "2.8px solid #3B5EAB" : "none")};
  padding: ${(props) => (props.expanded ? "0 1.25rem 0.5rem" : "0 1.25rem")};
  overflow: hidden;
  transition: all 0.3s ease;
  /* Improve touch interaction */
  -webkit-tap-highlight-color: rgba(59, 94, 171, 0.1);

  &:hover {
    cursor: pointer;
    outline: 2.8px solid ${(props) => (props.selected ? "#3B5EAB" : "#A9A9A9")};
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  }

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    width: 30rem;
    height: ${(props) => (props.expanded ? "8.5rem" : "4rem")};
    min-height: ${(props) => (props.expanded ? "8.5rem" : "4rem")};
    max-width: none;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    width: 32rem;
    height: ${(props) => (props.expanded ? "8.9rem" : "4rem")};
  }
`;

export const CardCost = styled.div`
  text-align: right;
  font-size: 0.875rem;
  color: #333;
  position: ${(props) => (props.forEngageCard ? "absolute" : "static")};
  right: ${(props) => (props.forEngageCard ? "0.5rem" : "auto")};
  top: ${(props) => (props.forEngageCard ? "0.25rem" : "auto")};
  font-weight: 700;
  background: white;
  padding: ${(props) => (props.forEngageCard ? "0.125rem 0.375rem" : "0")};
  z-index: 1;
  border-radius: 0.25rem;
  line-height: 1;
  flex-shrink: 0;
  white-space: nowrap;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1rem;
    right: ${(props) => (props.forEngageCard ? "1rem" : "auto")};
    top: ${(props) => (props.forEngageCard ? "0.5rem" : "auto")};
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    font-size: 1.125rem;
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: ${(props) => (props.expanded === false ? "center" : "flex-start")};
  flex-direction: ${(props) => (props.expanded === false ? "row" : "column")};
  justify-content: ${(props) => (props.expanded === false ? "space-between" : "flex-start")};
  border-bottom: ${(props) => (props.expanded ? "2px solid #a9a9a9" : "none")};
  padding-bottom: ${(props) => (props.expanded ? "0.5rem" : "0")};
  padding-top: ${(props) => (props.expanded ? "0.75rem" : "0")};
  position: relative;
  flex: ${(props) => (props.expanded ? "initial" : "1")};
`;

export const AdditionalPackagesTitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: none;
  padding-bottom: 0;
  position: relative;
`;

export const AdditionalPackagesCard = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 360px;
  height: auto;
  min-height: 4rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  outline: none;
  position: relative;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
  outline: ${(props) => (props.selected ? "2.8px solid #3B5EAB" : "none")};
  padding: 0 1.25rem;
  overflow: hidden;
  text-align: left;
  transition: all 0.3s ease;
  /* Improve touch interaction */
  -webkit-tap-highlight-color: rgba(59, 94, 171, 0.1);

  &:hover {
    cursor: pointer;
    outline: 2.8px solid ${(props) => (props.selected ? "#3B5EAB" : "#A9A9A9")};
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  }

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    width: 20rem;
    height: 4rem;
    max-width: none;
    min-height: 4rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    width: 21rem;
    height: 4rem;
  }
`;

export const AdditionalPackagesCardHeader = styled.div`
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
  padding: 0 3rem 0 0;
  text-align: left;
  color: #000;
  width: auto;
  word-wrap: break-word;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.25rem;
  }
`;

export const AdditionalPackagesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  position: relative;
  padding: 0 0.5rem;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    flex-direction: row;
    gap: 0.75rem;
    padding: 0;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    gap: 1rem;
  }
`;

export const BaseCrmCardHeader = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
  text-align: left;
  padding: ${(props) => (props.expanded ? "0.5rem 3rem 0.25rem 0" : "0 3rem 0 0")};
  width: ${(props) => (props.expanded ? "100%" : "auto")};
  word-wrap: break-word;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.25rem;
  }
`;

export const MasterExpandButton = styled.button`
  background: #3B5EAB;
  border: none;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #FFF;
  font-family: "DM Sans";
  font-size: 0.875rem;
  font-weight: 600;
  transition: opacity 0.2s ease;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);

  &:hover {
    opacity: 0.9;
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
  }

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1rem;
    padding: 0.625rem 1.25rem;
  }
`;

export const ExpandButton = styled.button`
  background: transparent;
  border: none;
  padding: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 16px;
    height: 16px;
    color: #688797;
  }
`;

export const BaseCrmCardSubHeader = styled.div`
  color: #6a6a6a;
  font-family: "DM Sans";
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.3;
  text-align: left;
  padding: 0 1rem 0.5rem 0;
  width: 100%;
  word-wrap: break-word;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1rem;
  }
`;

export const BaseCrmCardFooter = styled.div`
  color: #000;
  text-align: center;
  font-family: "DM Sans";
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.3;
  width: 100%;
  padding: 0.5rem 0.5rem 0.25rem;
  margin-top: auto;
  word-wrap: break-word;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1rem;
  }
`;

// Base CRM Card Package Details Header
export const PackageDetailsContainer = styled.div`
  display: flex;
  align-items: left;
  text-align: left;
  justify-content: left;
  flex-direction: column;
  flex-grow: 1;
  padding: 0;
  height: 100%;
  width: 100%;
`;

export const BaseCrmCardPackageDetailsHeader = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.3;
  padding: 0.25rem 0;
  word-wrap: break-word;
`;

// Base CRM Card Package Details
export const BaseCrmCardPackageDetails = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3;
  padding-left: 1rem;
  padding-bottom: 0.25rem;
  word-wrap: break-word;
`;

// ENGAGE PACKAGE

export const EngageCard = styled.button`
  display: flex;
  align-items: ${(props) => (props.expanded ? "flex-start" : "center")};
  justify-content: ${(props) => (props.expanded ? "flex-start" : "center")};
  flex-direction: column;
  width: 100%;
  max-width: 360px;
  height: auto;
  min-height: ${(props) => (props.expanded ? "10.1rem" : "4rem")};
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  outline: none;
  position: relative;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
  outline: ${(props) => (props.selected ? "2.8px solid #3B5EAB" : "none")};
  padding: ${(props) => (props.expanded ? "0 1.25rem 1.25rem" : "0 1.25rem")};
  overflow: hidden;
  transition: all 0.3s ease;
  /* Improve touch interaction */
  -webkit-tap-highlight-color: rgba(59, 94, 171, 0.1);

  &:hover {
    cursor: pointer;
    outline: 2.8px solid ${(props) => (props.selected ? "#3B5EAB" : "#A9A9A9")};
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  }

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    width: 20rem;
    height: ${(props) => (props.expanded ? "8.5rem" : "4rem")};
    max-width: none;
    min-height: ${(props) => (props.expanded ? "8.5rem" : "4rem")};
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    width: 21rem;
    height: ${(props) => (props.expanded ? "9.3rem" : "4rem")};
  }
`;

export const EngageCardHeader = styled.div`
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: ${(props) => (props.expanded ? "1.3" : "1")};
  padding: ${(props) => (props.expanded ? "0 3rem 0.25rem 0" : "0 3rem 0 0")};
  text-align: left;
  color: #000;
  width: ${(props) => (props.expanded ? "100%" : "auto")};
  word-wrap: break-word;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.25rem;
  }
`;

export const EngageCardSubHeader = styled.div`
  color: #6a6a6a;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.3;
  text-align: left;
  padding: 0 1rem 0.5rem 0;
  width: 100%;
  word-wrap: break-word;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1rem;
  }
`;

export const EngageCardPackageDetails = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.3;
  padding: 0.25rem 0.5rem;
  width: 100%;
  word-wrap: break-word;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 0.8rem;
  }
`;

// USER TYPE CARD
export const UserTypeSelectionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  position: relative;
  padding: 0 0.5rem;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    gap: 0.75rem;
  }
`;

export const UserTypeCard = styled.div`
  width: 100%;
  max-width: 360px;
  height: auto;
  min-height: ${(props) => (props.expanded ? "7.2rem" : "3.84rem")};
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  outline: ${(props) => (props.selected ? "2.8px solid #3B5EAB" : "none")};
  padding: 1rem;
  gap: 0.5rem;
  overflow: hidden;
  /* Improve touch interaction */
  -webkit-tap-highlight-color: rgba(59, 94, 171, 0.1);

  &:hover {
    cursor: pointer;
    outline: 2.8px solid ${(props) => (props.selected ? "#3B5EAB" : "#A9A9A9")};
  }

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    width: calc(50% - 0.5rem);
    max-width: none;
    min-height: ${(props) => (props.expanded ? "6.6rem" : "3.36rem")};
    padding: 0.875rem;
    gap: 0.5rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    width: 16rem;
    height: ${(props) => (props.expanded ? "8rem" : "4.48rem")};
    min-height: ${(props) => (props.expanded ? "8rem" : "4.48rem")};
  }
`;

export const UserTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding-left: 0;
  flex: 1;
  min-width: 0;
  gap: 0.5rem;
`;

export const UserTitleTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.1rem;
`;

export const UserTypeCardHeader = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
  padding-bottom: 0;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1rem;
    padding-bottom: 0;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    font-size: 1rem;
  }
`;

export const UserCardCost = styled.div`
  text-align: left;
  margin-left: 0;
  font-size: 0.75rem;
  color: #666;
  font-weight: 600;
  margin-bottom: 0;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 0.875rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    font-size: 0.875rem;
  }
`;

export const UserTypeCardSubHeader = styled.div`
  color: #6a6a6a;
  font-family: "DM Sans";
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.3;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 0.8rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    line-height: normal;
  }
`;

export const UserTypeCounterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 0.25rem;
`;

export const UserTypeCounter = styled.input`
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "DM Sans";
  font-size: 1.25rem;
  font-weight: 600;
  width: 2rem;
  border: none;
  outline: none;
  background: transparent;
  text-align: center;
  padding: 0;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.5rem;
    width: 2.5rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    font-size: 1.75rem;
    width: 3rem;
  }
`;

export const UserTypeRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  flex-shrink: 0;
`;

export const UserTypeCardButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding-right: 0;
  gap: 0.25rem;
`;

export const UserTypeCardButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem !important;
  height: 2.75rem !important;
  min-width: 2.75rem !important;
  min-height: 2.75rem !important;
  max-width: 2.75rem !important;
  max-height: 2.75rem !important;
  color: #666;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1;
  background: #f5f5f5;
  outline: none;
  border: 1px solid #d0d0d0;
  border-radius: 0.5rem;
  padding: 0 !important;
  margin: 0;
  flex-shrink: 0;
  box-sizing: border-box;
  /* Improve touch interaction */
  -webkit-tap-highlight-color: rgba(59, 94, 171, 0.1);

  &:hover {
    cursor: pointer;
    background: #f5f5f5;
    color: #666;
  }

  &:active {
    transform: translateY(1px);
    background: #e8e8e8;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    width: 1.75rem !important;
    height: 1.75rem !important;
    min-width: 1.75rem !important;
    min-height: 1.75rem !important;
    max-width: 1.75rem !important;
    max-height: 1.75rem !important;
    font-size: 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 0.25rem;
  }
`;
